module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/common/customer-seat-capacity-editor/customer-seat-capacity-editor.component.scss
// module id = ./src/app/modules/common-module/common/customer-seat-capacity-editor/customer-seat-capacity-editor.component.scss
// module chunks = 9